// extracted by mini-css-extract-plugin
export default {"root":"error_root__25qSa"};